import { Banner, BannerResult } from '../types/banner';

export const getFirstImage = (banner: Banner): string | undefined => {
  return banner.results?.find(r => r.type === 'image')?.url;
};

export const getFirstOptimizedImage = (banner: Banner): string | undefined => {
  return banner.results?.find(r => r.type === 'image')?.thumbnail;
};

export const getAllVideos = (banner: Banner): BannerResult[] => {
  return banner.results?.filter(r => r.type === 'video') || [];
};

export const getAllImages = (banner: Banner): BannerResult[] => {
  return banner.results?.filter(r => r.type === 'image' || r.type === 'gif') || [];
};
